import {
  SettingsFormControl,
  SettingsGroup,
  TextInputField
} from '@sequencehq/core-components'

import { MerchantBankAccountDetails } from '../bankDetails.types'

import { BASE_INPUT_FIELD_STYLES } from 'SettingsV2/settings.constants'
import { useForm } from '@sequencehq/utils'
import { required } from '@sequencehq/utils/validation'

export const useUkBankAccountForm = ({
  bankDetails,
  showValidationErrors
}: {
  bankDetails?: MerchantBankAccountDetails['value']
  showValidationErrors: boolean
}) => {
  return useForm({
    value: {
      accountNumber: bankDetails?.ukBankAccount?.accountNumber ?? '',
      sortCode: bankDetails?.ukBankAccount?.sortCode ?? ''
    },
    showValidationErrors,
    fieldConfiguration: [
      {
        property: 'accountNumber',
        validation: [required]
      },
      {
        property: 'sortCode',
        validation: [required]
      }
    ]
  })
}

export const UkBankAccountForm = ({
  fields
}: {
  fields: ReturnType<typeof useUkBankAccountForm>['fields']
}) => (
  <SettingsGroup title="Account details">
    <SettingsFormControl label="Account number" htmlFor="account-number">
      <TextInputField
        {...BASE_INPUT_FIELD_STYLES}
        placeholder="12345678"
        id="account-number"
        value={fields.accountNumber.value}
        validationErrors={fields.accountNumber.validationErrors}
        onChange={e => {
          fields.accountNumber.onChange(e.target.value)
        }}
      />
    </SettingsFormControl>

    <SettingsFormControl label="Sort code" htmlFor="sort-code">
      <TextInputField
        {...BASE_INPUT_FIELD_STYLES}
        placeholder="12345678"
        id="sort-code"
        value={fields.sortCode.value}
        validationErrors={fields.sortCode.validationErrors}
        onChange={e => {
          fields.sortCode.onChange(e.target.value)
        }}
      />
    </SettingsFormControl>
  </SettingsGroup>
)
